var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInternational(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "17px",
    viewBox: "0 0 17 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Internation") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Builder-MVP",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Settings_Themes",
    transform: "translate(-1008.000000, -448.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Internation",
    transform: "translate(1008.000000, 448.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#0071CE",
    x: 0,
    y: 0,
    width: 8.39999986,
    height: 8.39999986
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFC220",
    x: 8.39999986,
    y: 0,
    width: 8.39999986,
    height: 8.39999986
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#979797",
    strokeWidth: 0.1,
    fill: "#FFFFFF",
    x: 8.44999986,
    y: 8.44999986,
    width: 8.29999986,
    height: 8.29999986
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E5F0FA",
    x: 0,
    y: 8.39999986,
    width: 8.39999986,
    height: 8.39999986
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInternational);
export default __webpack_public_path__ + "static/media/international.d806b6f71b1b57ba06d52fc8de26298a.svg";
export { ForwardRef as ReactComponent };